import { Http } from '../../../../support';

const initialState = {
  data: [],
  busy: false,
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    const { external } = state;

    external.receptores.comprobantes.info = {
      ...external.receptores.comprobantes.info,
      ...data,
    };
  });
};

const info = async (store, id, params = {}) => {
  store.setState((state) => {
    const { external } = state;

    external.receptores.comprobantes.info = {
      ...external.receptores.comprobantes.info,
      busy: true,
    };
  });

  try {
    const response = await Http.get(`ext/receptores/facturas/${id}`, { params });
    store.setState((state) => {
      const { external } = state;

      external.receptores.comprobantes.info = {
        ...external.receptores.comprobantes.info,
        busy: false,
        data: response.data,
      };
    });
  } catch (error) {
    store.setState((state) => {
      const { external } = state;

      external.receptores.comprobantes.info = {
        ...external.receptores.comprobantes.info,
        busy: false,
        error: error.data || error,
      };
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    const { external } = state;

    external.receptores.comprobantes.info = {
      ...external.receptores.comprobantes.info,
      ...initialState,
    };
  });
};

const ExternalComprobanteInfoStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    info,
    reset,
  },
};

export default ExternalComprobanteInfoStore;
